'use client';

import React from 'react';

import classes from './footer.module.scss';
import FooterTermsButton from '@/components/footer/footer-terms-button';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';

function Footer({ lang }: { lang: Languages }) {
  const dict = useDictionary();

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.wrap}>
          <div className={classes.linkBox}>
            <div className={classes.footerLinks}>
              <FooterTermsButton
                buttonName={
                  lang === 'ko'
                    ? '개인정보처리방침'
                    : lang === 'ja'
                      ? 'プライバシーポリシー'
                      : 'Privacy Policy'
                }
                termsTitleKeys="mypage.privacyTerm"
                termsContentKey="privacy"
              />
              {lang !== 'ko' && (
                <FooterTermsButton
                  buttonName={
                    lang === 'ja' ? '利用規約' : 'Terms and Conditions of Use'
                  }
                  termsTitleKeys="mypage.useTerm"
                  termsContentKey="service"
                />
              )}
              <FooterTermsButton
                buttonName={
                  lang === 'ko'
                    ? '환불 규정'
                    : lang === 'ja'
                      ? '返金ポリシー'
                      : 'Refund Policy'
                }
                termsTitleKeys="mypage.refundTerm"
                termsContentKey="refund"
              />
              {lang === 'ja' && (
                <FooterTermsButton
                  buttonName="特定商取引法に基づく表記"
                  termsTitleKeys="mypage.jaSpecialLaw"
                  termsContentKey="specialLaw"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.wrap}>
        <div className={classes.linkBox}>
          <div className={classes.footerInfo}>
            <p>
              {lang === 'ko'
                ? '주식회사 글로브웨이브 | 대표자 : 강태훈 | 사업자등록번호 : 741-87-02551 | 통신판매업신고번호 : 2024-부산해운대-1512 | 사업장주소 : 부산광역시 해운대구 센텀중앙로 48, 1304호 | 유선전화번호 : 010-2778-5915'
                : 'globewave Co., Ltd. | CEO Taehoon Kang | Business Number\n' +
                  '              741-87-02551 | Mail-order-sales approval number\n' +
                  '              2023-부산해운대-1110 | 1304, 48, Centum jungang-ro, Haeundae-gu,\n' +
                  '              Busan, Republic of Korea'}
            </p>
            <p>© globewave Co., Ltd.</p>
            <p>
              For some products, GIFFINAN is a mail order intermediary and is
              not a party to the mail order sale. For applicable products,
              obligations and responsibilities regarding the product, product
              information, and transaction lie with the seller, so please check
              each product page for specific details.
            </p>
            <p>
              Unauthorized copying, transmission, distribution, crawling,
              scraping, etc. of the contents, UI, etc. of the Giffy Fan site are
              strictly prohibited by relevant laws such as the Copyright Act and
              the Content Industry Promotion Act.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
